import './index.scss';
import React, { PropTypes } from 'react';

const computeRGB = (start, end, percent) => 
    Math.round(start + percent * (end - start) / 100);

const getColor = (percent) => {
    const r0 = 60;
    const g0 = 133;
    const b0 = 223;

    const r1 = 70;
    const g1 = 201;
    const b1 = 109;

    return 'rgb(' + computeRGB(r0, r1, percent) + ',' + computeRGB(g0, g1, percent) + ',' + computeRGB(b0, b1, percent) + ')';
};

const ProgressBar = React.createClass({
    propTypes: {
        percent: PropTypes.number.isRequired
    },
    render: function () {
        const round = Math.round(this.props.percent);
        const percent = round + '%';
        const style = {
            width: percent,
            backgroundColor: getColor(this.props.percent)
        };

        return <div className="progressBar-container">
            <div className="progressBar-bar" style={style}></div>
        </div>;
    }
});

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/components/common/ProgressBar/index.jsx